export default {

    balls : {
        count : 80
    }


}


// WEBPACK FOOTER //
// gameConfig.js